import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableGridComponent, GridConfig } from '../configurable-grid/configurable-grid.component';
import { MasterDataService } from '../../../Services/master-data.service';
import { BaseInspectionOverview } from 'src/app/DTOs/InspectionMasterData/productDetailModel';

@Component({
  selector: 'app-identicaldesign',
  standalone: true,
  imports: [CommonModule, ConfigurableGridComponent],
  templateUrl: './identicaldesign.component.html',
  styleUrl: './identicaldesign.component.css'
})
export class IdenticalDesignComponent {
  gridConfig: GridConfig;

  constructor(private masterData: MasterDataService) {
    this.gridConfig = {
      getData: () => this.masterData.getIdenticalDesignOverview(),
      createItem: (item: BaseInspectionOverview) => this.masterData.createIdenticalDesign(item),
      updateItem: (id: number, item: BaseInspectionOverview) => this.masterData.updateIdenticalDesign(item.databaseId, item),
      deleteItem: (id: number) => this.masterData.deleteIdenticalDesign(id)
    };
  }
}
